<script>
    //Playing with animations :) :)
    import {fly, blur, fade} from 'svelte/transition'
</script>

<div class="modal-container" in:blur out:fade>
    <div class="modal-content" transition:fly = {{y:-200}}>
        <slot />
    </div>
</div>